import store from '@/store'

export const newSystem = {
  id: null,
  customer: '',
  department: '',
  toms: '',
  comments: [],
  attachments: [],
  modified_by: '',
  added: '',
  modified: '',
  name: '',
  purpose: '',
  storage_place: '',
  other_responsible: '',
  authentication: '',
  deletion: null,
  backup: '',
  remarks: null
}

export const newVT = {
  id: null,
  customer: '',
  system: null,
  system_id: null,
  affected_person: [],
  data_type: [],
  comments: [],
  attachments: [],
  tasks: [],
  modified_by: null,
  added: '',
  modified: '',
  name: '',
  description: null,
  purpose: '',
  process_type: '',
  data_origin: '',
  person_informed: false,
  person_informed_remarks: null,
  legal_base: '',
  data_protection: '',
  supplier: null,
  supplier_id: null,
  process_place: '',
  access_rights: '',
  storage_duration: '',
  intern_receipt: '',
  extern_receipt: '',
  data_transfer: false,
  data_transfer_remarks: null,
  profiling: false,
  profiling_remarks: null,
  evaluation: false,
  evaluation_remarks: null,
  document: null,
  storage_place: null,
  stand: null,
  departments: []
}

export const newTodo = {
  id: null,
  object_id: null,
  status: 'Offen',
  priority: 'Prio A',
  steps: [],
  comments: [],
  modified_by: '',
  assigned_to_char: '',
  origin: '',
  sequence: 0,
  description: '',
  on_hold: false,
  start_date: null,
  due_date: null,
  question: null,
  crm_works: null,
  last_escalation: '',
  customer: null,
  assigned_to: '',
  topic: null,
  model: '',
  recurring: false,
}


export const newWork = {
  id: null,
  subject: '',
  customer: null,
  contract: null,
  human_resource: null,
  start_time: null,
  worked_hours: 0.0,
  chargable_hours: 0.0,
  chargable_euro: 0.00,
  short_description: ''
}

export const newAudit = {
    "id": null,
    "customer": "",
    "default_start": "1999-12-01",
    "last_finish": null,
    "modified_by": "",
    "name": "",
    "description": "",
    "audit": true,
    "frequency": 12,
    "duration": 7,
    "question": 3256
}

export const newStep = {
  id: null,
  task: null,
  name: '',
  modified_by: '',
  assigned_to: '',
  status: 'Offen',
}

export const todoOriginText = {
  vt: 'Aktualisiert durch VT',
  question: 'Aktualisiert durch GAP Analyse',
  audit: 'Aktualisiert durch Audit/Review',
}

export const STATUS = [
  {value: 'Offen', label: 'Offen'},
  {value: 'In Bearbeitung', label: 'In Bearbeitung'},
  {value: 'Annulliert', label: 'Annulliert'},
  {value: 'Abgeschlossen', label: 'Abgeschlossen'},
  {value: 'Duplikat', label: 'Duplikat'},
]

export const PRIORITY = [
  {value: 'Prio A', label: 'Prio A'},
  {value: 'Prio B', label: 'Prio B'},
  {value: 'Prio C', label: 'Prio C'},
  {value: 'Prio D', label: 'Prio D'},
]

export const getURL = {
  question: (id) => `todos/v1/get_gap/${id}/`,
  supplier: (id) => `todos/v1/get_supplier/${id}/`,
  system: (id) => `todos/v1/get_system/${id}/`,
  vtverarbeiter: (id) => `todos/v1/get_vtverarbeiter/${id}/`,
  task: (id) => `todos/v1/get_task/${id}/`,
  vt: (id) => `todos/v1/get_vt/${id}/`,
}

export const objectModalName = {
  question: 'related_gap',
  questionSimple: 'related_simple_gap',
  questionSurvey: 'related_gap_survey',
  task: 'add_massnahme',
  system: 'related_system',
  vtverarbeiter: 'related_vtverarbeiter',
  supplier: 'related_supplier',
  vt: 'related_vt',
  incident: 'related_incident',
  sharedResponsibility: 'shared_responsibility',
  auditTemplate: 'audit_template',
  riskAnalysis: 'risk_analysis',
  riskSurvey: 'risk_survey',
  new_system_assessment: 'new_system_assessment',
  system_assessment: 'system_assessment',
}

export const newQuestion = {
  id: null,
  category: '',
  topic: {
  name: '',
    description: '',
    old_intern_number: '',
    new_intern_number: '',
    help_text:  ''
  },
  topic_internal_number: '',
  answers: [],
  last_answer: {},
  question_type: '',
  tasks: [],
  priority: '',
  comments: [],
  attachments: [],
  added: '',
  modified: '',
  name: '',
  old_intern_number: '',
  new_intern_number: '',
  description: '',
  help_text: '',
  statement_yes: '',
  statement_no: '',
  statement_partial: '',
  statement_irrelevant: '',
  content: '',
  customize_statement: '',
  points: 100,
  possible_task: '',
  intern_document_remark: '',
  document_required: null,
  isms_matching: null,
  remarks: '',
  modified_by: '',
  customer: null,
  departments: [],
  display_topics: [],
  intern_document: []
}

export const newAnswer= {
  id: null,
  comments: '',
  statementYes: '',
  statementNo: '',
  statementPartial: '',
  given_by: '',
  document: '',
  stand: '',
  modified_by: ''
}

export const  newSupplier = {
    "id": null,
    "customer": "",
    "data_type": [],
    "systems": [],
    "added": "",
    "modified": "",
    "name": "",
    "address": null,
    "description": "",
    "purpose": "",
    "place": "",
    "responsible_department": "",
    "data_processor": true,
    "legal_base": "",
    "contract": "",
    "responsible": "",
    "checked": false,
    "subcontractor": "",
    "subcontractor_checked": false,
    "document": null,
    "storage_place": null,
    "stand": null,
    "remarks": null,
    "modified_by": null
  }

export const newIncident = {
  "id": null,
  "customer": "",
  "modified_by": null,
  "added": "",
  "modified": "",
  "datetime": null,
  "reporter": "",
  "description": "",
  "consequence": "",
  "inform_lda": true,
  "date_inform_lda": null,
  "inform_affected": true,
  "inform_affected_remarks": "",
  "tasks": [],
  "followups": "",
  "responsible": "",
  "remarks": ""
}

export const newVTVerarbeiter = {
  "id": null,
  "toms": "",
  "added": "",
  "modified": "",
  "name": "",
  "description": "",
  "controller": "",
  "legal_base": "",
  "process_name": "",
  "stand": null,
  "modified_by": null,
  "customer": ""
}

export const newSharedResponsibility = {
  "id": null,
  "customer": "",
  "modified_by": null,
  "added": "",
  "modified": "",
  "processor": "",
  "how": "",
  "legal_base": "",
  "storage_place": "",
  "informer": "",
  "deleter": "",
  "responser": "",
  "remarks": "",
  "data_type": []
}

export const organizedResult = {
  "zutrittskontrolle": {
    "color": "ff0000",
    "points": 4,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Zugangskontrolle": {
    "color": "ff0000",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Zugriffskontrolle": {
    "color": "ff0000",
    "points": 3,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Weitergabekontrolle": {
    "color": "ff0000",
    "points": 6,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Pseudonymisierung": {
    "color": "ff0000",
    "points": 0,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Trennungskontrolle": {
    "color": "ff0000",
    "points": 4,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Eingabekontrolle": {
    "color": "ff0000",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Verfuegbarkeitskontrolle": {
    "color": "ff0000",
    "points": 5,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Auftragskontrolle": {
    "color": "00ff00",
    "points": 1,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Organisatorische": {
    "color": "00ff00",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  }
}

export const newRiskAnalysis = {
  "id": null,
  "comments": [],
  "vt_detail": {
    id: null,
    customer: '',
    name: ''
  },
  "vt": null,
  "reason": "",
  "description": "",
  "elementary_hazards": 0,
  "force_majeure": 0,
  "organizational_deficiencies": 0,
  "human_misactions": 0,
  "technical_failure": 0,
  "intentional_actions": 0,
  "failure_other_infrastructures": 0,
  "unintentional_attacks": 0,
  "targeted_it_attacks": 0,
  "computer_viruses_malware": 0,
  "eavesdropping_communication": 0,
  "theft_mobile_devices": 0,
  "data_transmission_third_countries": 0,
  "explanation_with_tom": 0,
  "bsi_basis": 0,
  "discrimination": 0,
  "identity_theft_fraud": 0,
  "financial_loss": 0,
  "reputation_damage": 0,
  "loss_confidentiality": 0,
  "violation_professional_secrets": 0,
  "unauthorized_reversal_pseudonymization": 0,
  "other_significant_economic_societal_disadvantages": 0,
  "loss_control_data": 0,
  "impairment_rights_freedoms": 0,
  "sensitive_data": 0,
  "personal_aspects": 0,
  "especially_vulnerable_persons": 0,
  "special_scope": 0,
  "dsgvo_basis": 0,
  "modified_by": null
}

export const RISKLEVEL = {
  'normal': 'Normal',
  'high': 'Hoch',
  'very high': 'Sehr Hoch',
}

export const dataTypeCategory = [
  {value: 'basis', label: 'Allgemeine Basisdaten/Stammdaten'},
  {value: 'special', label: 'Spezifische personenbezogene Daten'},
  {value: 'individual', label: 'Individuelle personenbezogene Daten'},
  {value: 'sensitive', label: 'Besondere Kategorien von personenbezogenen Daten'},
]

export const numberOfPerson = [
  {value: '<50', label: '<50'},
  {value: '50-99', label: '50-99'},
  {value: '100-200', label: '100-200'},
  {value: '>200', label: '>200'}
]

export const categoryChoices = {
  'Item 1': 'basis',
    'Item 2': 'special',
    'Item 3': 'individual',
    'Item 4': 'sensitive',
}

export const personNumberChoices = {
  'Item 1': '<50',
    'Item 2': '50-99',
    'Item 3': '100-200',
    'Item 4': '>200',
}

export const offlineModels = [
  'Gap Analyse',
  'Maßnahmenplan',
  'VT',
  'Risikobewertung',
  'VT(Selbst Datenverarbeiter)',
  'Gemeinsame Verantwortung',
  'Systeme',
  'Dienstleister',
  'Vorfälle',
  'Review/Audit',
  'AV Check',
  'TOM',
]

export const relatedModels = [
  ['Gap Analyse', 'Maßnahmenplan'],
  ['VT', 'Systeme', 'Dienstleister'],
]

export const  newSystemAssessment = {
  "id": null,
  "name": "",
  "survey": 9,
  "token": null,
  "password": null,
  "email": null,
  "customer": null,
  "result": null,
  "is_upgrade": false,
  "risk_analysis_result": null,
  "ai_results": [],
  "link_sent": false,
  "evaluation_path": null,
  "evaluation": null,
  "evaluated_by": null,
  "report_url": null,
  "status": "Offen",
  "valid_date": null,
  "approved": false,
  "template": false,
  "gap_entry": true,
  "created_by": null,
  "modified_by": null,
  "created_on": null,
  "modified_on": null,
}

export const newAIResult = {
  "id": null,
  "name": "",
  "survey": null,
  "token": null,
  "password": null,
  "email": null,
  "system_assessment": [],
  "result": {},
  "status": "Offen",
  "template": false,
  "link_sent": false,
  "created_by": null,
  "modified_by": null,
  "created_on": null,
  "modified_on": null,
}

/*export const offlineURLs = {
  'Gap Analyse': {
    list: [
      `todos/v1/irrelevant_questions/${store.account.accountid}/?cb=${Date.now()}`,
      `todos/v1/questions/${store.account.accountid}/?cb=${Date.now()}`,
    ],
    single: 'todos/v1/get_gap/{{ id }}'
  },
  'Maßnahmenplan': {
    list: [
      `todos/v1/get_tasks/${store.account.accountid}/`,
    ],
    single: 'todos/v1/get_task/{{ id }}/',
  },
  'VT': {
    list: [
      `todos/v1/vt/${store.account.accountid}/`
    ],
    single: ''
  },
  'Systeme': {
    single: 'todos/v1/get_system/{{ id }}/'
  },
  'Dienstleister': {
    single: 'todos/v1/get_supplier/{{ id }}/'
  }
}*/
